// src/pages/Home.jsx
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { StorageUtils, STORAGE_KEYS } from '@/utils/storage';
import { getUserFirstName } from '@/utils/user';

export function HomePage() {
  const { user, profile, loading } = useAuth();
  const navigate = useNavigate();
  const [checkingProfile, setCheckingProfile] = useState(
    !StorageUtils.hasItem(STORAGE_KEYS.PROFILE),
  );

  useEffect(() => {
    // Wait for initial auth and profile load
    if (loading) return;

    // If we have a profile, cache it and stop checking
    if (profile) {
      StorageUtils.setItem(
        STORAGE_KEYS.PROFILE,
        {
          exists: true,
          firstName: getUserFirstName({ profile }),
          userRole: profile.userRole,
          timestamp: Date.now(),
        },
        { expiry: 24 * 60 * 60 * 1000 }, // 24 hours expiry
      );
      setCheckingProfile(false);
      return;
    }

    // Only apply delay if no profile cache exists
    if (!StorageUtils.hasItem(STORAGE_KEYS.PROFILE)) {
      const timer = setTimeout(() => {
        if (!profile) {
          console.log(
            'No profile found after delay, redirecting to profile setup',
          );
          navigate('/profile');
        }
        setCheckingProfile(false);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      setCheckingProfile(false);
    }
  }, [profile, loading, navigate]);

  if (loading || checkingProfile) {
    return (
      <div className="sl-loading flex items-center justify-center min-h-screen">
        <div className="text-primary-400">Loading...</div>
      </div>
    );
  }

  // Use cached name if available, otherwise get from current data
  const cachedProfile = StorageUtils.getItem(STORAGE_KEYS.PROFILE, {
    defaultValue: {},
  });
  const firstName = getUserFirstName({ profile, user, cachedProfile });

  return (
    <div className="sl-home-page">
      <h1 className="sl-page-title text-2xl font-bold text-gray-900">
        Hey {firstName ? `${firstName} 👋` : '👋'}
      </h1>
      {/* Add your dashboard content here */}
    </div>
  );
}
